export default __webpack_public_path__ + "static/media/congrats-background.1f18ba66.png";